export default __webpack_public_path__ + "static/media/flame-test.740c4a58.jpg";